export default __webpack_public_path__ + "static/media/no_message.e795f906.svg";